module.exports = __webpack_public_path__ + "img/ramakrishna.81c0eb80.jpg";